import(/* webpackMode: "eager" */ "/workspace/purple-ventures/src/app/(public)/pitch-deck/page.tsx");
